import IconButton from '@/components/Buttons/IconButton';
import { MaskedIcon } from '@/components/MaskedIcon/MaskedIcon';
import PlusBlack from '@/images/plusBlack.svg';
import ThreeSquares from '@/images/ThreeSquares.svg';
import TrashLight from '@/images/TrashLight.svg';
import { useAdvancedEditorContext } from '@/pages/AdvancedEditor/context/useAdvancedEditorContext';
import theme from '@/theme';
import styled from '@emotion/styled';
import Tooltip from '@mui/material/Tooltip';
import { observer } from 'mobx-react-lite';

const Container = styled.div`
    height: 84px;
    border-radius: 10px;
    background-color: ${({ theme }) => theme.colors.black[100]};
    display: flex;
    align-items: center;
    justify-content: center;
    color: ${({ theme }) => theme.colors.secondary[900]};
    padding: 16px;
    gap: 16px;
`;

const TextContainer = styled.div`
    display: flex;
    width: calc(100% - 64px);
    align-items: center;
`;

const MainIcon = styled(MaskedIcon)`
    margin-right: 8px;
`;

const StyledIconButton = styled(IconButton)`
    color: ${({ theme }) => theme.colors.secondary.main} !important;
    background-color: #fff !important;
    font-weight: 600;
    border-radius: 8px;
    display: inline-flex;
    font-size: 16px;
    width: 32px;
    height: 32px;

    p {
        margin-left: 8px;
    }

    :focus {
        outline: none;
    }

    :hover {
        outline: 1px solid ${({ theme }) => theme.colors.black[200]};
        background-color: ${({ theme }) => theme.colors.black[200]} !important;
    }
`;

const Text = styled.p<{ fontFamily?: string }>`
    font-size: 16px;
    font-family: ${({ fontFamily }) => fontFamily || 'inherit'};
    max-height: 100%;
    overflow: hidden;
    text-overflow: ellipsis;
`;

export const CurrentValueControl = observer(() => {
    const { store } = useAdvancedEditorContext();

    const handleAdd = () => {
        store.selectElements([]);
    };

    const handleRemove = () => {
        const elementsIds = store.selectedElements.map(e => e.id);

        store.selectElements([]);
        store.deleteElements(elementsIds);
    };

    return (
        <Container>
            <TextContainer>
                <MainIcon src={ThreeSquares} size="21px" />
                <Text>Shape</Text>
            </TextContainer>

            <Tooltip
                title="Add new shape"
                placement="top"
                slotProps={{ tooltip: { sx: { backgroundColor: theme.colors.secondary[900], padding: '8px', fontSize: '14px' } } }}
                PopperProps={{
                    modifiers: [{ name: 'offset', options: { offset: [0, -6] } }],
                }}>
                <div data-testid="add-shape-button">
                    <StyledIconButton ariaLabel="Add" onClick={handleAdd}>
                        <MaskedIcon src={PlusBlack} size="18px" />
                    </StyledIconButton>
                </div>
            </Tooltip>

            <Tooltip
                title="Remove"
                placement="top"
                slotProps={{ tooltip: { sx: { backgroundColor: theme.colors.secondary[900], padding: '8px', fontSize: '14px' } } }}
                PopperProps={{
                    modifiers: [{ name: 'offset', options: { offset: [0, -6] } }],
                }}>
                <div>
                    <StyledIconButton ariaLabel="Remove" onClick={handleRemove}>
                        <MaskedIcon src={TrashLight} size="18px" />
                    </StyledIconButton>
                </div>
            </Tooltip>
        </Container>
    );
});
